module.exports = __webpack_public_path__ + "files/48cb685e0a0932905aef4b7f1d33d90b.svg";